import MuiBox, { BoxProps } from "@mui/material/Box";
import React from "react";

export const Box: React.FC<BoxProps> = (props) => {
  const { children, ...rest } = props;

  return <MuiBox {...rest}>{children}</MuiBox>;
};
